// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2_S3u","loaderOuter":"PageOverlayLoader_loaderOuter__19NzR"};